module.exports = __webpack_public_path__ + "img/no-data1-black.4866ce31.png";